import { Scope, Status } from 'generated/graphql';

export const ADD_DASHBOARD_COLLABORATOR_PARAM = 'addDashboardCollaborator';

export const DRAFT_DASHBOARD = {
  title: 'Untitled Dashboard',
  shortMetadata: '',
  createdAt: Math.floor(Date.now() / 1000),
  updatedAt: Math.floor(Date.now() / 1000),
  scope: Scope.Private,
  status: Status.Unarchived,
  description: '',
  editors: [],
  id: '',
  viewToken: '',
  editToken: '',
  metadata: '',
  isReportingDisabled: false,
  analysisIDs: [],
  tenantID: '',
  createdBy: {
    id: '',
    firstName: '',
    lastName: '',
  },
  version: 1,
};

export const GUTTER_SIZE = 20;

export const ROW_COL_SPAN = 12;

export const MIN_CELL_COL_SPAN = 3;
export const MIN_ROW_HEIGHT = 40;

export const ANALYSIS_WIDGET_MIN_HEIGHT = 480;
export const MEDIA_WIDGET_MIN_HEIGHT = 336;

export const MAX_CELLS_PER_ROW = 3;

export const INTERNAL_GUTTER_NUMBER = 11;

export const UPDATE_DASHBOARD_IN_PROGRESS_INFO =
  'An update is underway. Please wait 3 seconds before proceeding.';

export const DASHBOARD_SUBSCRIPTION_HELPCENTER_URL =
  'https://helpcenter.enterpret.com/en/articles/8754587-dashboard-sharing-reporting#h_98e1af5f32';

export const DASHBOARD_TV_MODE_POLL_DURATION = 15 * 60 * 1000; // 15 minutes

export const DASHBOARD_ACTIVE_CELL_ID = 'dashboard_active_cell_id';

export const DASHBOARD_DESCRIPTION_MAX_LENGTH = 300;

export const DASHBOARD_NAME_MAX_LENGTH = 100;

export const CELL_DRAG_IMAGE_CLASS = 'et-cell-drag-image';
export const CELL_DRAG_OVERLAY_CLASS = 'et-cell-drag-overlay';

export const MEDIA_URL_PATTERNS = [
  {
    name: 'YouTube',
    validateRegex:
      /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}(?:[&?][^\s]*)?$/,
    extractRegex:
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[&?][^\s]*)?/g,
    transform: (videoId: string) => `https://www.youtube.com/embed/${videoId}`,
  },
  {
    name: 'Loom',
    validateRegex:
      /^(?:https?:\/\/)?(?:www\.)?loom\.com\/share\/[a-zA-Z0-9_-]+(?:\?[^\s]*)?$/,
    extractRegex:
      /^(?:https?:\/\/)?(?:www\.)?loom\.com\/share\/([a-zA-Z0-9]+)(\?.*)?$/,
    transform: (videoId: string) => `https://www.loom.com/embed/${videoId}`,
  },
  {
    name: 'Descript',
    validateRegex:
      /^https:\/\/share\.descript\.com\/view\/[a-zA-Z0-9_-]+(?:\?[^\s]*)?$/,
    extractRegex:
      /^https:\/\/share\.descript\.com\/view\/([a-zA-Z0-9-]+)(\?.*)?$/,
    transform: (videoId: string) =>
      `https://share.descript.com/embed/${videoId}`,
  },
];
